import { ServiceProvider } from '@quasarcast/vue-service'
import { loggerServiceProvider } from 'plugins/logger/loggerServiceProvider'
import { orionPiniaOrmServiceProvider } from 'plugins/orion-pinia-orm/orionPiniaOrmServiceProvider'
import { userConfigServiceProvider } from 'plugins/user-config/userConfigServiceProvider'
import { permissionsServiceProvider } from './plugins/permissions/permissionsServiceProvider'
import { authServiceProvider } from './plugins/auth/authServiceProvider'

export const providers: ServiceProvider[] = [
  authServiceProvider,
  userConfigServiceProvider,
  orionPiniaOrmServiceProvider,
  permissionsServiceProvider,
  loggerServiceProvider,
]
